import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import { DISCLAIMER } from './constants';
import { NATIONAL_ID_ALREADY_EXISTS } from '../../constants';

import ErrorUnauthenticated from '../ErrorUnauthenticated';
import Screen from '../Screen';
import InputDOB from '../InputDOB';
import InputTIN from '../InputTIN';
import InputMonthlyIncome from '../InputMonthlyIncome';
import InputLoanUsageType from '../InputLoanUsageType';
import ButtonPrimary from '../ButtonPrimary';
import Disclaimers from '../Disclaimers';

import useForm from './useForm';
import Form from '../Form';

const CIP = () => {
  useRUMView('cip');

  const {
    form,
    handleSubmit,
    isSubmitting,
    error,
  } = useForm();

  if (error === NATIONAL_ID_ALREADY_EXISTS) {
    return (
      <ErrorUnauthenticated
        title="An account with the information you provided already exists."
        view="error_existing_account"
      />
    );
  }

  return (
    <Screen
      header="Just a little more about you."
      subheader="This entry is safe, secure, and won't impact your credit score."
    >
      <Form
        form={form}
        onSubmit={handleSubmit}
      >
        <InputTIN />
        <InputDOB />
        <InputMonthlyIncome />
        <InputLoanUsageType />
        <ButtonPrimary isLoading={isSubmitting}>
          Continue
        </ButtonPrimary>
      </Form>
      <Disclaimers>
        {DISCLAIMER}
      </Disclaimers>
    </Screen>
  );
};

export default CIP;
